import React from 'react';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from './ui/accordion';
import { faqs } from '../lib/seo';

const FaqSection = () => (
  <section className="bg-ktc-ivoryLight border-t border-ktc-cream" data-testid="faq-section">
    <div className="max-w-3xl mx-auto px-6 py-20 md:py-24">
      <div className="text-center mb-10">
        <span className="text-xs uppercase tracking-[0.2em] text-ktc-gold font-semibold">Frequently Asked</span>
        <h2 className="font-serif text-4xl md:text-5xl font-semibold text-ktc-green mt-3 text-balance">
          Export FAQs
        </h2>
        <p className="text-ktc-charcoal/70 mt-4">
          Common questions from buyers about sourcing rice, salt and grains direct from Pakistan.
        </p>
      </div>
      <Accordion type="single" collapsible className="border-t border-ktc-green/10">
        {faqs.map((f, i) => (
          <AccordionItem key={i} value={`faq-${i}`} className="border-ktc-green/10" data-testid={`faq-item-${i}`}>
            <AccordionTrigger className="font-serif text-lg md:text-xl text-ktc-green py-5 hover:no-underline">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-ktc-charcoal/75 text-base leading-relaxed pr-6">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);

export default FaqSection;
